module.exports = __webpack_public_path__ + "RMR DCA Guía de Inscripcion.pdf";